/* tslint:disable */
/* eslint-disable */
/**
 * EvictorAPI API
 * EvictorAPI handles Evictor operations for the target cluster.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AdvancedConfig } from '../models';
// @ts-ignore
import type { Config } from '../models';
// @ts-ignore
import type { Status } from '../models';
/**
 * EvictorAPIApi - axios parameter creator
 * @export
 */
export const EvictorAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Gets basic evictor configuration for the target cluster.  These are the settings that were previously in Policies.NodeDownscaler.Evictor in V1.
         * @param {string} clusterId The ID of the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evictorAPIGetConfig: async (clusterId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('evictorAPIGetConfig', 'clusterId', clusterId)
            const localVarPath = `/workload-eviction/v1/clusters/{clusterId}/config`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets evictor advanced configuration for the target cluster.
         * @param {string} clusterId The ID of the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evictorAPIGetEvictorAdvancedConfig: async (clusterId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('evictorAPIGetEvictorAdvancedConfig', 'clusterId', clusterId)
            const localVarPath = `/workload-eviction/v1/clusters/{clusterId}/advanced-config`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates basic evictor configuration for the target cluster.
         * @param {string} clusterId The ID of the cluster.
         * @param {Config} config 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evictorAPIUpdateConfig: async (clusterId: string, config: Config, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('evictorAPIUpdateConfig', 'clusterId', clusterId)
            // verify required parameter 'config' is not null or undefined
            assertParamExists('evictorAPIUpdateConfig', 'config', config)
            const localVarPath = `/workload-eviction/v1/clusters/{clusterId}/config`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(config, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upsert cluster\'s evictor advanced configuration.
         * @param {string} clusterId The ID of the cluster.
         * @param {AdvancedConfig} advancedConfig 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evictorAPIUpdateEvictorAdvancedConfig: async (clusterId: string, advancedConfig: AdvancedConfig, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('evictorAPIUpdateEvictorAdvancedConfig', 'clusterId', clusterId)
            // verify required parameter 'advancedConfig' is not null or undefined
            assertParamExists('evictorAPIUpdateEvictorAdvancedConfig', 'advancedConfig', advancedConfig)
            const localVarPath = `/workload-eviction/v1/clusters/{clusterId}/advanced-config`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(advancedConfig, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EvictorAPIApi - functional programming interface
 * @export
 */
export const EvictorAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EvictorAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Gets basic evictor configuration for the target cluster.  These are the settings that were previously in Policies.NodeDownscaler.Evictor in V1.
         * @param {string} clusterId The ID of the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async evictorAPIGetConfig(clusterId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Config>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.evictorAPIGetConfig(clusterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvictorAPIApi.evictorAPIGetConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gets evictor advanced configuration for the target cluster.
         * @param {string} clusterId The ID of the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async evictorAPIGetEvictorAdvancedConfig(clusterId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdvancedConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.evictorAPIGetEvictorAdvancedConfig(clusterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvictorAPIApi.evictorAPIGetEvictorAdvancedConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates basic evictor configuration for the target cluster.
         * @param {string} clusterId The ID of the cluster.
         * @param {Config} config 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async evictorAPIUpdateConfig(clusterId: string, config: Config, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Config>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.evictorAPIUpdateConfig(clusterId, config, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvictorAPIApi.evictorAPIUpdateConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upsert cluster\'s evictor advanced configuration.
         * @param {string} clusterId The ID of the cluster.
         * @param {AdvancedConfig} advancedConfig 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async evictorAPIUpdateEvictorAdvancedConfig(clusterId: string, advancedConfig: AdvancedConfig, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdvancedConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.evictorAPIUpdateEvictorAdvancedConfig(clusterId, advancedConfig, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvictorAPIApi.evictorAPIUpdateEvictorAdvancedConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EvictorAPIApi - factory interface
 * @export
 */
export const EvictorAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EvictorAPIApiFp(configuration)
    return {
        /**
         * Gets basic evictor configuration for the target cluster.  These are the settings that were previously in Policies.NodeDownscaler.Evictor in V1.
         * @param {EvictorAPIApiEvictorAPIGetConfigRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evictorAPIGetConfig(requestParameters: EvictorAPIApiEvictorAPIGetConfigRequest, options?: RawAxiosRequestConfig): AxiosPromise<Config> {
            return localVarFp.evictorAPIGetConfig(requestParameters.clusterId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets evictor advanced configuration for the target cluster.
         * @param {EvictorAPIApiEvictorAPIGetEvictorAdvancedConfigRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evictorAPIGetEvictorAdvancedConfig(requestParameters: EvictorAPIApiEvictorAPIGetEvictorAdvancedConfigRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdvancedConfig> {
            return localVarFp.evictorAPIGetEvictorAdvancedConfig(requestParameters.clusterId, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates basic evictor configuration for the target cluster.
         * @param {EvictorAPIApiEvictorAPIUpdateConfigRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evictorAPIUpdateConfig(requestParameters: EvictorAPIApiEvictorAPIUpdateConfigRequest, options?: RawAxiosRequestConfig): AxiosPromise<Config> {
            return localVarFp.evictorAPIUpdateConfig(requestParameters.clusterId, requestParameters.config, options).then((request) => request(axios, basePath));
        },
        /**
         * Upsert cluster\'s evictor advanced configuration.
         * @param {EvictorAPIApiEvictorAPIUpdateEvictorAdvancedConfigRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evictorAPIUpdateEvictorAdvancedConfig(requestParameters: EvictorAPIApiEvictorAPIUpdateEvictorAdvancedConfigRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdvancedConfig> {
            return localVarFp.evictorAPIUpdateEvictorAdvancedConfig(requestParameters.clusterId, requestParameters.advancedConfig, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for evictorAPIGetConfig operation in EvictorAPIApi.
 * @export
 * @interface EvictorAPIApiEvictorAPIGetConfigRequest
 */
export interface EvictorAPIApiEvictorAPIGetConfigRequest {
    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof EvictorAPIApiEvictorAPIGetConfig
     */
    readonly clusterId: string
}

/**
 * Request parameters for evictorAPIGetEvictorAdvancedConfig operation in EvictorAPIApi.
 * @export
 * @interface EvictorAPIApiEvictorAPIGetEvictorAdvancedConfigRequest
 */
export interface EvictorAPIApiEvictorAPIGetEvictorAdvancedConfigRequest {
    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof EvictorAPIApiEvictorAPIGetEvictorAdvancedConfig
     */
    readonly clusterId: string
}

/**
 * Request parameters for evictorAPIUpdateConfig operation in EvictorAPIApi.
 * @export
 * @interface EvictorAPIApiEvictorAPIUpdateConfigRequest
 */
export interface EvictorAPIApiEvictorAPIUpdateConfigRequest {
    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof EvictorAPIApiEvictorAPIUpdateConfig
     */
    readonly clusterId: string

    /**
     * 
     * @type {Config}
     * @memberof EvictorAPIApiEvictorAPIUpdateConfig
     */
    readonly config: Config
}

/**
 * Request parameters for evictorAPIUpdateEvictorAdvancedConfig operation in EvictorAPIApi.
 * @export
 * @interface EvictorAPIApiEvictorAPIUpdateEvictorAdvancedConfigRequest
 */
export interface EvictorAPIApiEvictorAPIUpdateEvictorAdvancedConfigRequest {
    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof EvictorAPIApiEvictorAPIUpdateEvictorAdvancedConfig
     */
    readonly clusterId: string

    /**
     * 
     * @type {AdvancedConfig}
     * @memberof EvictorAPIApiEvictorAPIUpdateEvictorAdvancedConfig
     */
    readonly advancedConfig: AdvancedConfig
}

/**
 * EvictorAPIApi - object-oriented interface
 * @export
 * @class EvictorAPIApi
 * @extends {BaseAPI}
 */
export class EvictorAPIApi extends BaseAPI {
    /**
     * Gets basic evictor configuration for the target cluster.  These are the settings that were previously in Policies.NodeDownscaler.Evictor in V1.
     * @param {EvictorAPIApiEvictorAPIGetConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvictorAPIApi
     */
    public evictorAPIGetConfig(requestParameters: EvictorAPIApiEvictorAPIGetConfigRequest, options?: RawAxiosRequestConfig) {
        return EvictorAPIApiFp(this.configuration).evictorAPIGetConfig(requestParameters.clusterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets evictor advanced configuration for the target cluster.
     * @param {EvictorAPIApiEvictorAPIGetEvictorAdvancedConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvictorAPIApi
     */
    public evictorAPIGetEvictorAdvancedConfig(requestParameters: EvictorAPIApiEvictorAPIGetEvictorAdvancedConfigRequest, options?: RawAxiosRequestConfig) {
        return EvictorAPIApiFp(this.configuration).evictorAPIGetEvictorAdvancedConfig(requestParameters.clusterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates basic evictor configuration for the target cluster.
     * @param {EvictorAPIApiEvictorAPIUpdateConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvictorAPIApi
     */
    public evictorAPIUpdateConfig(requestParameters: EvictorAPIApiEvictorAPIUpdateConfigRequest, options?: RawAxiosRequestConfig) {
        return EvictorAPIApiFp(this.configuration).evictorAPIUpdateConfig(requestParameters.clusterId, requestParameters.config, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upsert cluster\'s evictor advanced configuration.
     * @param {EvictorAPIApiEvictorAPIUpdateEvictorAdvancedConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvictorAPIApi
     */
    public evictorAPIUpdateEvictorAdvancedConfig(requestParameters: EvictorAPIApiEvictorAPIUpdateEvictorAdvancedConfigRequest, options?: RawAxiosRequestConfig) {
        return EvictorAPIApiFp(this.configuration).evictorAPIUpdateEvictorAdvancedConfig(requestParameters.clusterId, requestParameters.advancedConfig, options).then((request) => request(this.axios, this.basePath));
    }
}

